import React from 'react'
import {Flex} from "./layout"
import Overline from './_Overline'
import GallerySmall from './_GallerySmall'
import Superface from '../Superface'
import MenuItemSoon from './_MenuItemSoon'
import Swiper from 'swiper'

class About extends React.Component{

    constructor(props){
        super(props)
        this.handleResize = this.handleResize.bind(this)
        this.handleScroll = this.handleScroll.bind(this)
    }

    componentDidMount(){
        Superface.setCompass('S')
        this.initSliders()
        this.setState({
            ...this.state,
            mounted : true,
        })
        window.addEventListener('resize', this.handleResize)
        this.container.addEventListener('scroll', this.handleScroll)
    }
    
    componentWillMount(){
        document.title = Superface.translate('Notre métier') + ' - Superface'
        this.setState({
            mounted : false,
            hideCompass : false
        })
    }
    
    componentWillUnmount(){
        Superface.setCompassHiddenOnMobile(false)
        window.removeEventListener('resize', this.handleResize)
        this.container.removeEventListener('scroll', this.handleScroll)
    }

    handleResize(){
        this.setState({...this.state})
    }
    
    handleScroll(e){
        const scrollTop = this.container.scrollTop
        
        if( scrollTop > 30 && !this.state.hideCompass ){
            
            Superface.setCompassHiddenOnMobile(true)
            this.setState({
                ...this.state,
                hideCompass : true
            })
        }
        
        if( scrollTop < 30 && this.state.hideCompass ){
            Superface.setCompassHiddenOnMobile(false)
            this.setState({
                ...this.state,
                hideCompass : false
            })
        }

    }

    render(){

        return(
            <div ref={ el => this.container = el } id="notre-metier" className={"notre-metier-mobile" + (this.state.mounted ? ' mounted' : '')} style={{backgroundColor:'white', width:'100vw', height:'100vh', overflow:'scroll'}}>

                {this.renderPage()}

            </div>
        )
        
    }

    initSliders(){
        
        // addClass( this.sliderExp, 'slider-exp' )

        const params = { 
			speed : 400, 
            initialSlide : 0
        }
        
        setTimeout( () => {
            this.swiperExp = new Swiper('.slider-exp' , params)
            this.swiperMilan = new Swiper('.slider-milan' , params)
        }, 2000)

    }


    renderPage(){
        const { about } = this.props
        
        const largeText = { 
            fontSize : ( Superface.IS_MOBILE ? '1.4rem' : '2rem' ), 
            margin : ( Superface.IS_MOBILE ? '0 2rem' : '0 6rem' ),
        }
        
        if( about ){
            let expSlides = [ about.image_4, about.image_5, about.image_6, about.image_7 ]    
            return(
                <div>
                    
                    {/* TEXT TOP -------------------------------  */}

                        <div style={{marginTop:'10rem'}} >
                            <SectionTitle title={ Superface.field( this.props.about, 'section_title_1' ) } />
                        </div>

                        <Flex align="center" justify="center">
                            <div style={{...largeText}} dangerouslySetInnerHTML={ this.crtmrkp( Superface.field(about, 'text_1')) } />
                        </Flex>

                        <Flex align="center" justify="center">
                            <div style={largeText} dangerouslySetInnerHTML={ this.crtmrkp( Superface.field(about, 'text_2')) } />
                        </Flex>

                    {/* SKILLS -------------------------------  */}
                        
                        <SectionTitle title={ Superface.field( this.props.about, 'section_title_2' ) } />

                        <div 
                            id="skills"
                            style={{ margin: (window.innerWidth > 767 ? '4rem 6rem' : '4rem 2rem' ) }}
                            >
                                
                                
                                    <div>
                                        <h2>Recherche</h2>
                                        <div dangerouslySetInnerHTML={this.crtmrkp( Superface.field( about, 'recherche'))} />
                                    </div>
                                    <br/>
                                    <div>
                                        <h2>Proposition</h2>
                                        <div dangerouslySetInnerHTML={this.crtmrkp( Superface.field( about, 'proposition'))} />
                                    </div>
                                    <br/>    
                                    <div>
                                        <h2>Developpement</h2>
                                        <div dangerouslySetInnerHTML={this.crtmrkp( Superface.field( about, 'developpement'))} />
                                    </div>
                                    <br/>
                                    <div>
                                        <h2>Suivi</h2>
                                        <div dangerouslySetInnerHTML={this.crtmrkp( Superface.field( about, 'suivi'))} />
                                    </div>

                                

                        </div>

                    {/* SHAPES -------------------------------  */}

                        <SectionTitle title={ Superface.field( this.props.about, 'section_title_3' ) } />

                        <div 
                            id="shapes"
                            >

                            <div style={largeText} dangerouslySetInnerHTML={this.crtmrkp( Superface.field(about, 'text_4'))} />
                        
                        </div>   
                        
                        <div style={{position:'relative'}}>
                            

                                <img className='shapes-image-mobile' src={require('../images/galaxy-1.svg')} alt="forme filaire"/>
                                <img className='shapes-image-mobile' src={require('../images/galaxy-2.svg')} alt="forme filaire"/>
                                <img className='shapes-image-mobile' src={require('../images/galaxy-3.svg')} alt="forme filaire"/>
                                
                            
                        </div>

                    {/* 3DS -------------------------------  */}

                        <div id="milans">
                            
                            <Flex align="center" direction='column' justify="center" style={{width:'100%'}}>
                                <img src={Superface.assetUrl(about.image_backup_video_galaxy.path)} alt="logo" />
                            </Flex>

                        </div>

                    {/* EXPERIENCE -------------------------------  */}

                        <SectionTitle title={ Superface.field( this.props.about, 'section_title_4' ) } />
                    
                        <div className="experience-left">
                            
                            <div 
                                id="experience-text-1"
                                >
                                <div style={largeText} dangerouslySetInnerHTML={ this.crtmrkp( Superface.field( about, 'text_5'))} />
                            </div>
                            
                            <div 
                                id="experience-text-2"
                                >
                                <div style={largeText} dangerouslySetInnerHTML={ this.crtmrkp( Superface.field( about, 'text_6'))} />
                            </div>

                        </div>

                        <div className="experience-right">
                            <div style={{padding:'2rem 0'}}>
                                <GallerySmall slides={expSlides} name="exp" i="exp" />
                            </div>
                        </div>


                    

                    {/* IMAGES MILAN -------------------------------  */}
                        
                        <SectionTitle title={ Superface.field( this.props.about, 'section_title_5' ) } />

                        <div id="images-milan">
                            <GallerySmall slides={about.milans} name="milans" i="milans" />
                        </div>

                   
                    {/* TEAM -------------------------------  */}
                    
                        <SectionTitle title={ Superface.field( this.props.about, 'section_title_6') } />
                        <Flex 
                            direction="row-reverse"
                            justify="center"
                            id="team-mobile"
                            style={{
                                width:(window.innerWidth > 767 ? '80%' : 'calc(100vw)' ), 
                                marginLeft: (window.innerWidth > 767 ? '10%' : '0' ), 
                            }}
                            >
                            {this.renderMembers(this.props.about.team)}
                        </Flex>
                    

                    {/* CONTACT -------------------------------  */}
                    
                        
                        <SectionTitle title={ '' } />
                        {/* <SectionTitle title={ Superface.field( this.props.about, 'section_title_7' ) } /> */}

                        <div 
                            id="contact"
                            >
                            <Flex align="center" justify="center" style={{position:'relative', minHeight:'40vh', width:'100vw'}}>
                                <div style={{...largeText, color:'black', position:'relative', zIndex:50, width:'420px'}}>
                                    { Superface.field(this.props.about, 'text_merci') }
                                    <br/>
                                    <br/>
                                    <a href={this.props.contact.facebook} target="_blank" style={{ display:'inline-block', width:'2rem'}}>
                                        <img src={require('../images/facebook-black.svg')} alt="facebook" />
                                    </a>
                                    &nbsp;&nbsp;
                                    <a href={this.props.contact.instagram} target="_blank" style={{ display:'inline-block', width:'2rem'}}>
                                        <img src={require('../images/instagram-black.svg')} alt="instagram" />
                                    </a>
                                    
                                    <div style={{fontSize:'1rem', marginTop:'5vh', width:'50%'}}>
                                        {Superface.translate('Crédits:')}
                                        <br/>
                                        { Superface.translate('Direction artistique et site internet : ')}
                                        <a className="overline-link" href="https://www.bureaukayser.com/" target="_blank">
                                            <Overline>Bureau Kayser</Overline>
                                        </a>
                                        <br/>
                                        {Superface.translate('Photos : ')}
                                        <a className="overline-link" href="https://marvinleuvrey.com/" target="_blank">
                                            <Overline>Marvin Leuvrey</Overline>
                                        </a>
                                    </div>    

                                    <div style={{position:'absolute', width:'20vw', left:'70%', top:'55%', zIndex:'8'}}>
                                        <img src={require('../images/milan-circle.svg')} alt="Pièce de Milan"/>
                                    </div>

                                </div>
                               
                            </Flex>
                        
                        </div>
                            
                        <div style={{width:'100%', height:'4rem', borderTop:'1px solid black'}}>
                            
                            <Flex justify="space-around">
                            
                                <div className="footer-link" style={{marginTop:0}}>
                                    <span className="overline-link" onClick={ () => { Superface.goTo( Superface.uri('contact') ) }}>
                                        <Overline>{ Superface.translate('Contact') }</Overline>
                                    </span>
                                </div>

                                <div className="footer-link" style={{marginTop:0}}>
                                    <span className="overline-link"  onClick={ () => { Superface.goTo( Superface.uri('matieres') ) }}>
                                        <Overline>{ Superface.translate('Matières') }</Overline>
                                    </span>
                                </div>
                                
                                <div className="footer-link" style={{marginTop:0}}>
                                    {/* <span className="overline-link" onClick={ () => { Superface.goTo( Superface.uri('projets') ) }}>
                                        <Overline>{ Superface.translate('Projets') }</Overline>
                                    </span> */}
                                    <MenuItemSoon display={Superface.translate('Projets')} style={{display:'inline-block', width:'auto'}} />
                                </div>
                            
                            </Flex>
                            
                        </div>

                </div>
            )
        }

    }
    
    renderMembers(members){
        return members.map( (data, i) => {
            let member = { ...data.value }
            let style = {width:'25%', margin:'0 2%', textAlign:'center'}
            return(
                <div key={'member-'+i} className="member-mobile" style={style}>
                    <Flex direction="column" align="center">
                        
                        <div>
                            <img src={Superface.assetUrl(member.image.path)} alt={member.firstname + ' ' + member.lastname }/>
                        </div>

                        <div style={{fontSize:'1rem', marginTop:'3rem', width : (window.innerWidth > 767 ? 'initial' : '80%' ) }}>
                            {member.firstname + ' ' + member.lastname}
                        </div>
                        
                        <div style={{fontSize:'0.7rem', marginTop:'1rem'}}>
                            { member.roles.map( (role,i) => <div key={'role_'+i} >{role}</div> )}
                        </div>
                        
                    </Flex>
                </div>
            )
        })
    }


    crtmrkp(text){
        return { __html : text }
    }

}

export default About

const SectionTitle = (props) => {
    return <div style={{width:'100%', textAlign:'center', margin:'10rem 0 3rem'}}>{Superface.translate(props.title)}</div>
}



// WEBPACK FOOTER //
// ./src/components/mobile_About.js